import { isEqual } from 'lodash'
import { ObjectsToLoad } from 'proseShared/prompts/MentionPrompt/MentionPrompt'
import { useArticles } from 'proseShared/prompts/queries/useArticles'
import { useAlgoliaClient } from 'providers/AlgoliaClientProvider'
import qs from 'qs'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useDebounce } from 'react-use'
import { RootState } from 'types'

export const useDocs = (_query: string, enabled?: boolean) => {
  const [inputQuery, setInputQuery] = useState('')
  useDebounce(
    () => {
      if (_query === inputQuery) return
      setInputQuery(_query)
    },
    100,
    [_query, setInputQuery],
  )
  const location = useLocation()
  const params = qs.parse(location.search, { ignoreQueryPrefix: true })
  const userId = params.userId
  const auth = useSelector((state: RootState) => state.auth, isEqual)
  const algoliaClient = useAlgoliaClient()
  const articlesAndFoldersQuery = useArticles({
    algoliaClient,
    auth,
    userId,
    editableDocsOnly: false,
    suggestRecentlyReadArticle: true,
    objectsToLoad: [ObjectsToLoad.Articles],
    query: inputQuery,
    disabled: !enabled,
  })

  return articlesAndFoldersQuery.data
}
